/**
 * @ngdoc component
 * @name  common.shopcart.component:ItxShopCartPrice
 * @description
 * Shop cart price component.
 * Used by the shop cart to show the price and eventually if there is any discount will show the old and new price.
 * @param {object} item - Product object
 */
(function () {
    'use strict';

    var ItxShopCartPriceCmp = {
        bindings: {
            item: '<',
            currency: '<',
            customized: '<'
        },
        controller: ItxShopCartPriceCmpCtrl,
        templateUrl: 'shop-cart-price.component.html'
    };

    ItxShopCartPriceCmpCtrl.$inject = ['ItxTranslateSvc', 'CommonServices', 'CmsConfigSvc'];

    function ItxShopCartPriceCmpCtrl(ItxTranslateSvc, CommonServices, CmsConfigSvc) {
        var _this = this;

        _this.$onInit = function () {
            _this.classes = '';

            _this.formatPrice = inditex.formatPrice.bind(inditex);

            _this.price = _this.formatPrice(_this.item.unitPrice * _this.item.quantity);

            if (_this.item.state && _this.item.state.selectedSize) {
                _this.checkOldPrice(_this.item.state.selectedSize);
            } else if (_this.item.colors && _this.item.colors.length > 0) {
                var colorObject = _.filter(_this.item.colors, function (color) {
                    return color.id == _this.item.colorId;
                });

                if (colorObject && colorObject.length > 0) {
                    var sizeObject = _.filter(colorObject[0].sizes, function (size) {
                        return size.sku == _this.item.sku;
                    });

                    var size = sizeObject[0];
                    _this.checkOldPrice(size);
                }
            }

            CommonServices.isVip().then((isVip) => {
                if (_this.item.subitems) {
                    let totalPrice = 0;
                    _this.item.subitems.forEach((subitem) => {
                        totalPrice += subitem.unitPrice;
                    });
                    _this.price = _this.formatPrice(totalPrice * _this.item.quantity);
                    _this.priceAlternates = inditex.getPriceInAllCurrencies(totalPrice * _this.item.quantity);
                } else if (
                    _this.item.detail &&
                    _this.item.detail.colors[0] &&
                    _this.item.detail.colors[0].customizations &&
                    _this.item.detail.colors[0].customizations.customizationDetails.price &&
                    !isVip &&
                    _this.customized
                ) {
                    _this.price = _this.formatPrice(
                        (Number(_this.item.unitPrice) + Number(_this.item.detail.colors[0].customizations.customizationDetails.price)) *
                            _this.item.quantity
                    );
                    _this.priceAlternates = inditex.getPriceInAllCurrencies(
                        (Number(_this.item.unitPrice) + Number(_this.item.detail.colors[0].customizations.customizationDetails.price)) *
                            _this.item.quantity
                    );
                } else if (_this.item.unitPrice) {
                    _this.price = _this.formatPrice(_this.item.unitPrice * _this.item.quantity);
                    _this.priceAlternates = inditex.getPriceInAllCurrencies(_this.item.unitPrice * _this.item.quantity);
                } else {
                    _this.price = _this.formatPrice(0);
                    _this.priceAlternates = inditex.getPriceInAllCurrencies(0);
                }

                if (inditex.iStoreJSON.details.alternateLocales && inditex.iStoreJSON.details.alternateLocales.length > 0) {
                    const price = _this.item.unitPrice * _this.item.quantity;
                    const priceRated = Math.round(price * inditex.iStoreJSON.details.alternateLocales[0].conversionRate);
                    _this.alternatePrice = '(' + inditex.formatPriceForCurrency(priceRated, inditex.iStoreJSON.details.alternateLocales[0]) + ')';
                }
                CmsConfigSvc.getProperty('enable_croacia').then(function (enabled) {
                    if (enabled && _this.currency === 'HRK') {
                        const price = _this.item.unitPrice * _this.item.quantity;
                        _this.price = inditex.formatPriceForCurrency(price, inditex.iStoreJSON.details.alternateLocales[0]);
                        const priceAlternateInv = Math.round(price * inditex.iStoreJSON.details.alternateLocales[0].conversionRateInv);
                        _this.alternatePrice = '(' + inditex.formatPriceForCurrency(priceAlternateInv, inditex.iStoreJSON.details.locale) + ')';
                    }
                });
            });
        };
        /**
         * @ngdoc method
         * @methodOf common.shopcart.component:ItxShopCartPrice
         * @name  onChanges
         * @description
         * When quantity of items is updated in parent component this function will reload component in order
         * to show the updated information.
         */
        _this.$onChanges = function (changeObj) {
            if (!changeObj.item.isFirstChange() && changeObj.item.currentValue.quantity != changeObj.item.previousValue.quantity) {
                _this.$onInit();
            }
        };

        _this.checkOldPrice = function (size) {
            if (_this.item.unitComparePrice && _this.item.unitComparePrice !== 0) {
                _this.isOldPrice = true;
                _this.oldPrice = _this.formatPrice(_this.item.unitComparePrice * _this.item.quantity);
                const oldPriceUnit = _this.item.unitComparePrice * _this.item.quantity;
                _this.oldPriceAlternates = '(' + inditex.formatPriceForCurrency(oldPriceUnit, inditex.iStoreJSON.details.alternateLocales[0]) + ')';
            }

            if (!_this.oldPrice) {
                _this.isOldPrice = size.oldPrice && size.oldPrice.length > 0 && size.oldPrice != null;

                if (_this.isOldPrice) {
                    _this.isOldPriceSize = true;
                    _this.oldPrice = _this.formatPrice(size.oldPrice * _this.item.quantity);
                    const oldPriceUnit = size.oldPrice * _this.item.quantity;
                    _this.oldPriceAlternates =
                        '(' + inditex.formatPriceForCurrency(oldPriceUnit, inditex.iStoreJSON.details.alternateLocales[0]) + ')';
                }
            }
            CmsConfigSvc.getProperty('enable_croacia').then(function (enabled) {
                if (enabled && _this.currency === 'HRK') {
                    let oldPriceUnit = 0;
                    if (_this.isOldPriceSize) {
                        oldPriceUnit = size.oldPrice * _this.item.quantity;
                    } else {
                        oldPriceUnit = _this.item.unitPrice * _this.item.quantity;
                    }
                    _this.oldPrice = inditex.formatPriceForCurrency(oldPriceUnit, inditex.iStoreJSON.details.alternateLocales[0]);
                    const priceAlternateInv = Math.round(oldPriceUnit * inditex.iStoreJSON.details.alternateLocales[0].conversionRateInv);
                    _this.oldPriceAlternates = '(' + inditex.formatPriceForCurrency(priceAlternateInv, inditex.iStoreJSON.details.locale) + ')';
                }
            });
        };
    }

    angular.module('itxApp.common').component('itxShopCartPrice', ItxShopCartPriceCmp);
})();
